import { Provider } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map } from 'rxjs';

import { RELOAD_TOAST, ReloadToastConfiguration, ReloadToastOpener } from '@ninety/platform/state';
import { ReloadToastComponent } from '@ninety/ui/core';

export const RELOAD_TOAST_PROVIDERS: Provider[] = [
  {
    provide: RELOAD_TOAST,
    useFactory:
      (snackBar: MatSnackBar): ReloadToastOpener =>
      (config?: ReloadToastConfiguration) =>
        snackBar
          .openFromComponent(ReloadToastComponent, {
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: 'app-update',
            data: config,
          })
          .afterDismissed()
          .pipe(map(({ dismissedByAction }) => dismissedByAction)),
    deps: [MatSnackBar],
  },
];
